import kr from '../../kr/kr';

export default class WooCountry extends kr.Component {
    init() {
        this.$ = window.jQuery;
        this.bind();
    }

    bind() {
        const self = this;
        this.$(this.$element).on('change', '#billing_country, #shipping_country', function() {
            const value = this.value;
            self.$('.delivery-country select[name="country"]').val(value).change();
        });
    }
}

kr.registerComponent('.js-wooTabs', {
    component: WooCountry
});